<template>
    <tr :class="`${isEditRequested || isAddRequested ? 'edit-row' : ''}`">
        <td :colspan="`${isEditRequested || isAddRequested ? '2' : '1'}`" class="align-top">
            <div class="form-group form-check custom-checkbox mt-2">
                <input type="checkbox" id="payable" class="form-check-input" :checked="detail.isPayable" disabled />
                <label class="form-check-label mb-1 pb-2" for="payable"></label>
            </div>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(detail.startTime)" />
        </td>
        <td>
            <EmptyTextHandler :text="formatingDateOrTime(detail.startTime, 'hh:mm A')" />
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(detail.endTime)" />
        </td>
        <td>
            <EmptyTextHandler :text="formatingDateOrTime(detail.endTime, 'hh:mm A')" />
        </td>
        <td>
            <EmptyTextHandler :text="detail.units" />
        </td>
        <td><span v-if="detail.rate">$</span><EmptyTextHandler :text="detail.rate" /></td>
        <td>
            <EmptyTextHandler :text="detail.rateTypeText" />
        </td>
        <td>
            <EmptyTextHandler :text="detail.isPaid ? 'Yes' : 'No'" />
        </td>
        <td class="text-end">
            <i> No Actions </i>
        </td>
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEditDetail()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEditDetail()">
                Cancel
            </button>
        </td>
        <td class="button-cell text-end" v-if="isAddRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="save()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelSaveNewDetail()">
                Cancel
            </button>
        </td>
    </tr>
</template>

<script lang="ts" src="./PayrollDetailsRow.ts"></script>
